export interface ConfirmDialogOptions {
    title: string;
    description?: string;
    cancelText?: string;
    confirmText?: string;
}

// This will be populated by the provider
let confirmDialogImpl: (
    options: ConfirmDialogOptions,
) => Promise<boolean> = () =>
    Promise.reject(new Error("ConfirmDialogProvider not initialized"));

export const setConfirmDialogImpl = (
    impl: (options: ConfirmDialogOptions) => Promise<boolean>,
) => {
    confirmDialogImpl = impl;
};

export const getConfirmDialogImpl = () => confirmDialogImpl;
